import { Skeleton } from '@chakra-ui/react';

import { StickyBar } from '@app/components/molecules/sticky-bar';

export const SwitchStickyBarSkeleton = () => (
    <StickyBar insetX="0" bgColor="transparent" position="fixed" px="gutterWidth" boxShadow="none">
        <Skeleton height="40px" />
    </StickyBar>
);
